"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "swiper/css";
const Image = ({ src, alt = "", fill, priority, quality, sizes, ...props }) => (
  <img
    src={src}
    alt={alt}
    sizes={sizes}
    loading={priority ? "eager" : "lazy"}
    {...props}
    style={fill ? { ...props.style, position: "absolute", inset: 0, width: "100%", height: "100%" } : props.style}
  />
);
const omImages = [
    "/images/OM Edited/DSC02492.webp",
    "/images/OM Edited/DSC02376.webp",
    "/images/OM Edited/DSC02732.webp",
    "/images/OM Edited/DSC02770.webp",
    "/images/OM Edited/DSC03248.webp",
    "/images/OM Edited/DSC02807.webp",
    "/images/OM Edited/DSC02566.webp",
    "/images/OM Edited/DSC03438.webp",
    "/images/OM Edited/DSC03414.webp",
    "/images/OM Edited/DSC03493.webp",
];
const OmImages = () => {
    return (_jsx("section", { className: "relative w-full overflow-hidden bg-white py-12 sm:py-16 lg:py-20", children: _jsxs("div", { className: "relative mx-auto max-w-[84rem] px-4 sm:px-8 lg:px-12", children: [_jsx(Swiper, { modules: [Autoplay, Navigation], navigation: {
                        nextEl: ".om-images-next",
                        prevEl: ".om-images-prev",
                    }, autoplay: { delay: 4200, disableOnInteraction: false }, loop: true, speed: 850, slidesPerView: 1, className: "om-images-swiper", children: omImages.map((image) => (_jsx(SwiperSlide, { children: _jsx("div", { className: "relative aspect-[16/9] w-full overflow-hidden rounded-[20px] bg-[#f3eee7]", children: _jsx(Image, { src: image, alt: "\u30D2\u30EB\u30AA\u30FC\u30E0\u306E\u65BD\u8A2D\u3068\u98A8\u666F", fill: true, sizes: "(max-width: 1536px) 100vw, 1536px", className: "object-cover transition-transform duration-700 hover:scale-[1.03]", quality: 88 }) }) }, image))) }), _jsx("button", { type: "button", className: "om-images-prev absolute left-5 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white disabled:opacity-40 sm:left-10 lg:left-14", "aria-label": "\u524D\u306E\u753B\u50CF", title: "\u524D\u306E\u753B\u50CF", children: _jsx(FiChevronLeft, { className: "h-6 w-6", "aria-hidden": "true" }) }), _jsx("button", { type: "button", className: "om-images-next absolute right-5 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white disabled:opacity-40 sm:right-10 lg:right-14", "aria-label": "\u6B21\u306E\u753B\u50CF", title: "\u6B21\u306E\u753B\u50CF", children: _jsx(FiChevronRight, { className: "h-6 w-6", "aria-hidden": "true" }) })] }) }));
};
export default OmImages;
